"use client";

import { Button, Flex, Heading, Text } from "@radix-ui/themes";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { FC } from "react";
import Container from "@/components/entities/container";
import S from "./index.module.scss";

type ErrorProps = {
  title?: string;
  text?: string;
  actionLabel?: string;
  actionHref?: string;
  onAction?: () => void;
};

const Error: FC<ErrorProps> = ({ title, text, actionLabel, actionHref = "/", onAction }) => {
  const t = useTranslations("errorPage");

  return (
    <div className={S.page}>
      <Container>
        <div className={S.content}>
          <Flex direction="column" gap="4" align="start">
            <Text size="2" className={S.eyebrow}>
              {t("eyebrow")}
            </Text>
            <Heading size="8" className={S.title}>
              {title || t("title")}
            </Heading>
            <Text size="3" className={S.description}>
              {text || t("description")}
            </Text>

            {onAction ? (
              <Button size="3" onClick={onAction}>
                {actionLabel || t("actions.home")}
              </Button>
            ) : (
              <Button asChild size="3">
                <Link href={actionHref}>{actionLabel || t("actions.home")}</Link>
              </Button>
            )}
          </Flex>
        </div>
      </Container>
    </div>
  );
};

export default Error;
